import { cloneDeep } from 'lodash'

import render from './render'

export default function(options) {
  return {
    data() {
      return {
        showFileManager: false,

        field: undefined
      }
    },

    computed: {
      proxy() {
        return {
          privacyPolicy: cloneDeep(options.settings?.[`${options.path}.privacyPolicy`]),
          publicOffer: cloneDeep(options.settings?.[`${options.path}.publicOffer`])
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
